<script>
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import i18n from "../i18n";

/* eslint-disable no-console */
/**
 * Item List component
 */
export default {
  components: {
    Input,
    Area, 
  },
  data() {
    return {
    };
  },
  mounted() {
    
  },
  methods: {
    show: function() {
      this.$refs[this.id].show();
    },
    getTitle: function() {
      
      return `${i18n.t('property.text')}: ${this.title}`
    },

    getStatus: function() {
      return this.item != null && this.item.status.replace("<br/><div style=\"font-size: 6.5pt; margin-top: 5px;\">", "  ").replace("</div>", " ");
    },

    getPrice: function() {
      return  this.item != null && this.filters.numFormat(this.item.price, `0,0.00`);
    }

  },
  props: {
    id: {
      type: String,
    },
    item: {
      type: Object,
    },
    title: {
      type: String,
    },
    filters: null,
  },
};
</script>
<template>
  <div>
      <b-modal
        :id="id"
        :ref="id"
        centered
        size="xl"
        :title='getTitle()'
        title-class="font-22"
        hide-footer
        :hide-header-close="true"
      >
        <div class="row">
          <div class="col-lg-8">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <Input 
                      :id="'project_id'"
                      :disabled="true"
                      :label="'property.project'"
                      :value="this.item != null && this.item.project"
                    /> 

                  </div>
                  <div class="col-md-6">
                    <Input 
                      :id="'project_floor_id'"
                      :disabled="true"
                      :label="'property.floor'"
                      :value="this.item != null && this.item.floor"
                    /> 
                  </div>
                </div>
                <div class="row">
                  
                  <div class="col-md-6">
                    <Input 
                      :id="'property_group_id'"
                      :disabled="true"
                      :label="'property.group'"
                      :value="this.item != null && this.item.group"
                    /> 
                  </div>
                  <div class="col-md-6">
                    <Input 
                      :id="'property_type_id'"
                      :disabled="true"
                      :label="'property.type'"
                      :value="this.item != null && this.item.type"
                    /> 
                  </div>
                </div>
                <div class="row">
                  
                  <div class="col-md-6">
                    <Input 
                      :id="'property_status_id'"
                      :disabled="true"
                      :label="'property.status'"
                      :value="getStatus()"
                    />
                  </div>
                  <div class="col-md-6">
                    <Input 
                      :id="'price'"
                      :disabled="true"
                      :label="'property.price'" 
                      :value="getPrice()"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <Input 
                      :last="'general.square'"
                      :id="'cross_size'"
                      :disabled="true"
                      :label="'property.gross-size'" 
                      :value="this.item != null && this.item.cross_size"
                    />
                  </div>
                  <div class="col-md-6">
                    <Input 
                      :last="'general.square'"
                      :id="'net_size'"
                      :disabled="true"
                      :label="'property.net-size'" 
                      :value="this.item != null && this.item.net_size"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <Area 
                      :rows="7"
                      :id="'description'"
                      :disabled="true"
                      :label="'property.description'" 
                      :value="this.item != null && this.item.description"
                     />
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card">
              <div class="card-body">
                
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
</template>